import formConfig from '../rn-form-config.json';
import type { FieldDef, SectionDef, RefDataItem } from '../../shared/composables/useFormRenderer';
import { useFormRenderer } from '../../shared/composables/useFormRenderer';
import companySubtypes from '../../shared/data/common/company-subtypes.json';

export type { FieldDef, SectionDef, RefDataItem };

// ===== Composable =====
export function useRnFormConfig() {
  const { sharedRefData, companySubtypesMap } = useFormRenderer();

  const sections = formConfig.sections as SectionDef[];
  // Merge options from config with companySubtypes from JSON
  const options = {
    ...formConfig.options,
    subType: companySubtypesMap as Record<string, { value: string; label: string }[]>,
  } as Record<string, any>;
  const idTypeMapping = formConfig.idTypeMapping as {
    byName: Record<string, string>;
    byCode: Record<string, string>;
    byDisplayName: Record<string, string>;
  };
  const validation = formConfig.validation as Record<string, { pattern: string; message: string }>;

  // refData includes idTypes from shared
  const refData: Record<string, RefDataItem[]> = { ...sharedRefData };

  return {
    formConfig,
    sections,
    options,
    idTypeMapping,
    validation,
    refData,
  };
}
